<div class="mt-lg-4">
  <visitation-report
    past-reports-url="/dashboard/generatereports-ef-fsm"
    [environment]="environment">
  </visitation-report>
</div>